import React, { useState } from 'react';

const ImsForm = ({ initialValues, onSubmit, onCancel, isEditMode = false }) => {

    const [gstinOfSupplier, setGstinOfSupplier] = useState(initialValues?.gstinOfSupplier || '');
    const [tradeOrLegalName, setTradeOrLegalName] = useState(initialValues?.tradeOrLegalName || '');
    const [invoiceNumber, setInvoiceNumber] = useState(initialValues?.invoiceNumber || '');
    const [invoiceType, setInvoiceType] = useState(initialValues?.invoiceType || 'Regular'); // Default value
    const [invoiceDate, setInvoiceDate] = useState(initialValues?.invoiceDate || ''); // Store as string in YYYY-MM-DD
    const [invoiceValue, setInvoiceValue] = useState(initialValues?.invoiceValue || '');
    const [status, setStatus] = useState(initialValues?.status || 'pending'); // Default value
    const [placeOfSupply, setPlaceOfSupply] = useState(initialValues?.placeOfSupply || '');
    const [taxableValue, setTaxableValue] = useState(initialValues?.taxableValue || '');
    const [integratedTax, setIntegratedTax] = useState(initialValues?.integratedTax || '');
    const [centralTax, setCentralTax] = useState(initialValues?.centralTax || '');
    const [stateTax, setStateTax] = useState(initialValues?.stateTax || '');
    const [cess, setCess] = useState(initialValues?.cess || '');
    const [source, setSource] = useState(initialValues?.source || 'GSTR-1/IFF'); // Default value
    const [sourceReturnPeriod, setSourceReturnPeriod] = useState(initialValues?.sourceReturnPeriod || '');
    const [sourceFilingStatus, setSourceFilingStatus] = useState(initialValues?.sourceFilingStatus || 'Filed'); // Default value
    const [month, setMonth] = useState(initialValues?.month || '');
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);  // Add loading state


    const handleSubmit = async () => {
        setError(null);
        setLoading(true);  // Set loading to true when submit starts

        // Basic Validation (expand as needed)
        if (!gstinOfSupplier || !tradeOrLegalName || !invoiceNumber || !invoiceDate || !invoiceValue || !placeOfSupply || !taxableValue) {
            setError('Please fill in all required fields.');
            setLoading(false); // Reset loading if validation fails
            return;
        }


        const imsData = {
            gstinOfSupplier,
            tradeOrLegalName,
            invoiceNumber,
            invoiceType,
            invoiceDate: invoiceDate, // Send YYYY-MM-DD directly
            invoiceValue: parseFloat(invoiceValue),
            status,
            placeOfSupply,
            taxableValue: parseFloat(taxableValue),
            integratedTax: parseFloat(integratedTax),
            centralTax: parseFloat(centralTax),
            stateTax: parseFloat(stateTax),
            cess,
            source,
            sourceReturnPeriod,
            sourceFilingStatus,
            month
        };

        try {
            await onSubmit(imsData);  // Pass data to parent
        } catch (err) {
            setError(err.message || 'Failed to submit IMS data.');
        } finally {
             setLoading(false); // Reset loading in finally block
        }
    };

    const handleCancelForm = () => {
        onCancel();
    };



    return (
        <div className="bg-white rounded-lg shadow-sm p-6">
            {error && (
                <div className="bg-red-50 text-red-700 p-4 rounded-lg mb-4">
                    {error}
                </div>
            )}

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">GSTIN of Supplier</label>
                    <input
                        type="text"
                        value={gstinOfSupplier}
                        onChange={(e) => setGstinOfSupplier(e.target.value)}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Trade or Legal Name</label>
                    <input
                        type="text"
                        value={tradeOrLegalName}
                        onChange={(e) => setTradeOrLegalName(e.target.value)}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Invoice Number</label>
                    <input
                        type="text"
                        value={invoiceNumber}
                        onChange={(e) => setInvoiceNumber(e.target.value)}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Invoice Type</label>
                    <select
                        value={invoiceType}
                        onChange={(e) => setInvoiceType(e.target.value)}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    >
                        <option value="Regular">Regular</option>
                        <option value="SEZ">SEZ</option>
                        {/* Add more options as needed */}
                    </select>
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Invoice Date</label>
                    <input
                        type="date"
                        value={invoiceDate}
                        onChange={(e) => setInvoiceDate(e.target.value)}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Invoice Value</label>
                    <input
                        type="number"
                        value={invoiceValue}
                        onChange={(e) => setInvoiceValue(e.target.value)}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                </div>
                 <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Status</label>
                    <select
                        value={status}
                        onChange={(e) => setStatus(e.target.value)}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    >
                        <option value="pending">Pending</option>
                        <option value="approved">Approved</option>
                         <option value="rejected">Rejected</option>
                        {/* Add more options as needed */}
                    </select>
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Place of Supply</label>
                    <input
                        type="text"
                        value={placeOfSupply}
                        onChange={(e) => setPlaceOfSupply(e.target.value)}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Taxable Value</label>
                    <input
                        type="number"
                        value={taxableValue}
                        onChange={(e) => setTaxableValue(e.target.value)}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Integrated Tax</label>
                    <input
                        type="number"
                        value={integratedTax}
                        onChange={(e) => setIntegratedTax(e.target.value)}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Central Tax</label>
                    <input
                        type="number"
                        value={centralTax}
                        onChange={(e) => setCentralTax(e.target.value)}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">State Tax</label>
                    <input
                        type="number"
                        value={stateTax}
                        onChange={(e) => setStateTax(e.target.value)}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Cess</label>
                    <input
                        type="number"
                        value={cess}
                        onChange={(e) => setCess(e.target.value)}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Source</label>
                    <select
                        value={source}
                        onChange={(e) => setSource(e.target.value)}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    >
                        <option value="GSTR-1/IFF">GSTR-1/IFF</option>
                        {/* Add more options as needed */}
                    </select>
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Source Return Period</label>
                    <input
                        type="text"
                        value={sourceReturnPeriod}
                        onChange={(e) => setSourceReturnPeriod(e.target.value)}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Source Filing Status</label>
                    <select
                        value={sourceFilingStatus}
                        onChange={(e) => setSourceFilingStatus(e.target.value)}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    >
                        <option value="Filed">Filed</option>
                        <option value="Not Filed">Not Filed</option>
                        {/* Add more options as needed */}
                    </select>
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Month</label>
                    <input
                        type="text"
                        value={month}
                        onChange={(e) => setMonth(e.target.value)}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                </div>
            </div>

            <div className="mt-6 flex justify-end space-x-4">
                <button
                    type="button"
                    className="px-4 py-2 text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50"
                    onClick={handleCancelForm}
                >
                    Cancel
                </button>
                <button
                    type="button"
                    className="px-4 py-2 text-white bg-blue-600 rounded-lg hover:bg-blue-700 disabled:opacity-50"
                    onClick={handleSubmit}
                    disabled={loading}
                >
                    {loading ? 'Adding...' : (isEditMode ? 'Update IMS Data' : 'Add IMS Data')}
                </button>
            </div>
        </div>
    );
};

export default ImsForm;